import * as THREE from "three";
import { Context } from "../core/context";
import { DBEntity, DbLine } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  MultiPipeAnnotationModifyReturnData,
} from "@/core/Parameters";
import { WasmUtil } from "@/utils/WasmUtil";

class MultiPipeAnnotationModify implements IModifyOperation {
  private m_context: Context;
  private m_points: THREE.Vector3[] = [];
  public get Points() {
    return this.m_points;
  }
  private m_locationObject: THREE.Line;
  private m_TextLabel: ULabel;
  // private m_curSelect: DbLine | undefined;
  private m_selects: DbLine[] = [];
  private m_scale = 1;
  private m_intervalLength: number = 0.1;
  private m_tempLineObject: THREE.LineSegments | undefined;
  private m_tempBoxObject: THREE.LineSegments | undefined;
  private m_curState: string = "rightTop";
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_textHeight = 350;
  private m_cueLine3!: THREE.Line3;
  private m_tempAuxLine: THREE.LineSegments | undefined;
  private m_auxLineVector = new THREE.Vector3();
  private m_crossData: THREE.Matrix4[] = [];
  private m_auxLineInsertSignSGroup: THREE.Group = new THREE.Group();
  private m_returnData: MultiPipeAnnotationModifyReturnData | [] = [];
  private m_callbackUnderway: (point: THREE.Vector3) => void;

  constructor(
    context: Context,
    callbackUnderway: (point: THREE.Vector3) => void
  ) {
    this.m_context = context;
    this.m_callbackUnderway = callbackUnderway;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_selects = this.m_context.SelectionManager.GetSelected() as DbLine[];
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
    this.m_tempObjectGroup.add(this.m_auxLineInsertSignSGroup);
    this.createAuxLine();
    this.createTempLineObject();
    this.createTempBoxObject();
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point;
    this.m_locationObject.position.copy(this.m_curPoint);
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 35;
    TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_points.length == 0) {
      // this.m_TextLabel.SetVaule(
      //   "请选择要操作的管线",
      //   TextLabelLocation,
      //   new THREE.Vector3(1, 0, 0)
      // );
    } else if (this.m_points.length == 1) {
      // this.m_TextLabel.SetVaule(
      //   "再次点取将确定操作",
      //   TextLabelLocation,
      //   new THREE.Vector3(1, 0, 0)
      // );
      this.updatedAuxLine();
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    let { obejct } = point;
    if (obejct && obejct.length > 0 && obejct[0] instanceof DbLine) {
      if (!this.m_points.length) {
        for (let i = 0; i < this.m_selects.length; i++) {
          let select = this.m_selects[i];
          if (select == obejct[0]) {
            this.m_points.push(point.point.clone());
            this.m_cueLine3 = new THREE.Line3(
              new THREE.Vector3(
                select.points[0],
                select.points[1],
                select.points[2]
              ),
              new THREE.Vector3(
                select.points.at(-3),
                select.points.at(-2),
                select.points.at(-1)
              )
            );
            return;
          }
        }
      }
    }
    if (this.m_points.length == 1) {
      this.m_callbackUnderway(point.point.clone());
      this.m_points.push(point.point.clone());
    }
  }
  onKeyDown(e: KeyboardEvent): void {}
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    let arr = this.m_tempAuxLine!.geometry!.attributes?.position?.array;
    if (arr) {
      let points = Array.from(arr);
      let auxLineStartPoint = new THREE.Vector3(
        points[0],
        points[1],
        points[2]
      );
      let auxLineEndPoint = new THREE.Vector3(points[3], points[4], points[5]);

      this.m_returnData = {
        startPoint: auxLineStartPoint,
        endPoint: auxLineEndPoint,
        signMatrixs: this.m_crossData,
      };
    } else {
      this.m_returnData = [];
    }

    this.clear();
    if (operate == ModifyOperateState.complete) {
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private createAuxLineInsertSign(matrix: THREE.Matrix4) {
    let geo = new THREE.BufferGeometry();
    geo.setFromPoints([
      new THREE.Vector3(-0.15, 0, 0),
      new THREE.Vector3(0.15, 0, 0),
    ]);
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let auxLineInsertSign = new THREE.LineSegments(geo, mat);
    auxLineInsertSign.frustumCulled = false;
    auxLineInsertSign.applyMatrix4(matrix);
    this.m_auxLineInsertSignSGroup.add(auxLineInsertSign);
  }

  private createTempLineObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    this.m_tempLineObject = new THREE.LineSegments(geo, mat);
    this.m_tempLineObject.frustumCulled = false;
    this.m_tempObjectGroup.add(this.m_tempLineObject);
  }
  private updateTempLineObject(matrix: THREE.Matrix4) {
    let w = (this.m_textHeight / 1000) * 3.5;
    let h = this.m_textHeight / 1000 + this.m_intervalLength * 2;
    let tempLinePoints = [];

    for (let i = 0; i < this.m_crossData.length; i++) {
      let m_points = [
        new THREE.Vector3(0, i * h, 0),
        new THREE.Vector3(w, i * h, 0),
        new THREE.Vector3(0, i * h, 0),
        new THREE.Vector3(0, (i + 1) * h, 0),
        new THREE.Vector3(0, (i + 1) * h, 0),
        new THREE.Vector3(w, (i + 1) * h, 0),
      ];
      tempLinePoints.push(...m_points);
    }
    this.m_tempLineObject!.geometry.setFromPoints(tempLinePoints);
    this.m_tempLineObject!.geometry.applyMatrix4(matrix.clone());
  }

  private createTempBoxObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    this.m_tempBoxObject = new THREE.LineSegments(geo, mat);
    this.m_tempBoxObject.frustumCulled = false;
    this.m_tempObjectGroup.add(this.m_tempBoxObject);
  }

  private updateTempBoxObject(matrix: THREE.Matrix4) {
    let intervalLength = this.m_intervalLength;
    let boxW = (this.m_textHeight / 1000) * 3;
    let boxH = this.m_textHeight / 1000;
    let baseH = this.m_textHeight / 1000 + this.m_intervalLength * 2;
    let tempBoxPoints = [];
    let baseW = intervalLength;
    for (let i = 0; i < this.m_crossData.length; i++) {
      let m_points = [
        new THREE.Vector3(baseW, i * baseH + boxH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + boxH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + boxH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW, i * baseH + boxH + intervalLength, 0),
      ];
      tempBoxPoints.push(...m_points);
    }
    this.m_tempBoxObject!.geometry.setFromPoints(tempBoxPoints);
    this.m_tempBoxObject!.geometry.applyMatrix4(matrix.clone());
  }

  private createAuxLine() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    this.m_tempAuxLine = new THREE.LineSegments(geo, mat);
    this.m_tempAuxLine.frustumCulled = false;
    this.m_tempObjectGroup.add(this.m_tempAuxLine);
  }
  private updatedAuxLine() {
    let closeSelectP = new THREE.Vector3();
    this.m_cueLine3.closestPointToPoint(this.m_curPoint, false, closeSelectP);
    let result = this.m_cueLine3.closestPointToPointParameter(
      closeSelectP,
      false
    );
    if (result >= 0 && result <= 1) {
      this.m_tempAuxLine?.geometry.setFromPoints([
        closeSelectP,
        this.m_curPoint,
      ]);
      this.m_auxLineVector = new THREE.Vector3().subVectors(
        this.m_curPoint,
        closeSelectP
      );
    } else if (result < 0) {
      this.m_tempAuxLine?.geometry.setFromPoints([
        this.m_cueLine3.start,
        this.m_cueLine3.start.clone().add(this.m_auxLineVector),
      ]);
    } else if (result > 1) {
      this.m_tempAuxLine?.geometry.setFromPoints([
        this.m_cueLine3.end,
        this.m_cueLine3.end.clone().add(this.m_auxLineVector),
      ]);
    }
    let points = Array.from(
      this.m_tempAuxLine!.geometry.attributes.position.array
    );
    let tempObjectMatrix = new THREE.Matrix4();
    let auxLineStartPoint = new THREE.Vector3(points[0], points[1], points[2]);
    let auxLineEndPoint = new THREE.Vector3(points[3], points[4], points[5]);
    let q = new THREE.Quaternion();

    let xAxis = new THREE.Vector3(1, 0, 0);
    let yAxis = new THREE.Vector3(0, 1, 0);
    let zAxis = new THREE.Vector3(0, 0, 1);
    this.m_auxLineVector = auxLineEndPoint.clone().sub(auxLineStartPoint);
    let sourceSelect = this.m_selects[0];
    let sourceSelectVector = new THREE.Vector3(
      sourceSelect.points[3],
      sourceSelect.points[4],
      sourceSelect.points[5]
    )
      .sub(
        new THREE.Vector3(
          sourceSelect.points[0],
          sourceSelect.points[1],
          sourceSelect.points[2]
        )
      )
      .normalize();
    let isClockwise = false;
    if (this.m_auxLineVector.clone().cross(xAxis).z > 0) {
      isClockwise = true;
    }
    let rotateVector = this.m_auxLineVector
      .clone()
      .normalize()
      .applyAxisAngle(zAxis, Math.PI / 2);
    let qAngle = this.m_auxLineVector.clone().normalize().angleTo(xAxis);
    if (!isClockwise) {
      this.m_curState = "rightTop";
      qAngle -= Math.PI / 2;
    } else if (isClockwise) {
      this.m_curState = "rightBottom";
      qAngle = -qAngle;
      qAngle += Math.PI / 2;
    }
    q.setFromAxisAngle(zAxis, qAngle);
    tempObjectMatrix.compose(auxLineEndPoint, q, new THREE.Vector3(1, 1, 1));
    this.computerIntersection(points);
    this.updateTempLineObject(tempObjectMatrix);
    this.updateTempBoxObject(tempObjectMatrix);
  }

  private computerIntersection(points: number[]) {
    let auxLine = {
      points,
    };
    this.m_crossData.length = 0;
    this.m_context.ToolsManager.GroupClear(this.m_auxLineInsertSignSGroup);
    this.m_auxLineInsertSignSGroup = new THREE.Group();
    this.m_tempObjectGroup.add(this.m_auxLineInsertSignSGroup);
    let xAxis = new THREE.Vector3(1, 0, 0);
    for (let i = 0; i < this.m_selects.length; i++) {
      let crossPoints = WasmUtil.IntersectPoints(
        this.m_context,
        auxLine as unknown as DBEntity,
        this.m_selects[i],
        this.m_context.SelectionManager.Scale
      );
      if (crossPoints.length) {
        let selectObjStartP = new THREE.Vector3(
          this.m_selects[i].points![0],
          this.m_selects[i].points![1],
          this.m_selects[i].points![2]
        );
        let selectObjEndP = new THREE.Vector3(
          this.m_selects[i].points![3],
          this.m_selects[i].points![4],
          this.m_selects[i].points![5]
        );
        let selectVectorNormal = selectObjEndP
          .clone()
          .sub(selectObjStartP)
          .normalize();
        let angle = selectVectorNormal.angleTo(xAxis);
        if (selectVectorNormal.clone().cross(xAxis).z > 0) {
          angle = -angle;
        }

        angle += Math.PI / 4;
        let q = new THREE.Quaternion().setFromAxisAngle(
          new THREE.Vector3(0, 0, 1),
          angle
        );
        let matrix = new THREE.Matrix4().compose(
          crossPoints[0],
          q,
          new THREE.Vector3(1, 1, 1)
        );
        this.m_crossData.push(matrix);
      }
    }
    for (let i = 0; i < this.m_crossData.length; i++) {
      this.createAuxLineInsertSign(this.m_crossData[i]);
    }
  }

  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_context.ToolsManager.ObjectsClear([this.m_locationObject]);
    this.m_TextLabel.dispose();
  }
}

export { MultiPipeAnnotationModify };
